"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("~/consts/routes");
function ProtectedRoute() {
    const isUserLogged = JSON.parse(localStorage.getItem('isUserLogged'));
    return !isUserLogged ? react_1.default.createElement(react_router_dom_1.Navigate, { to: routes_1.ROUTE_LOGIN, replace: true }) : react_1.default.createElement(react_router_dom_1.Outlet, null);
}
exports.default = ProtectedRoute;
